// extracted by mini-css-extract-plugin
export default {"content":"style_content__GpdXZ","itemName":"style_itemName__ZPID-"};